import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type LegacyCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LegacyCatalogQuery = { __typename?: 'query_root', legacyCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', id: string, entryName: string, flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string, brand?: Types.Maybe<string> }> }> }>, combinedPicture?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', alternativeText?: Types.Maybe<string>, formats?: Types.Maybe<any> }> }> }> }> }> }> }> }> }> }>>> }> }> }> };


export const LegacyCatalogDocument = gql`
    query legacyCatalog {
  legacyCatalog: b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries(filters: {category: {eq: "legacy"}}) {
          id
          entryName
          flagship {
            data {
              id
              attributes {
                smartphoneVariant {
                  data {
                    id
                    attributes {
                      slug
                      smartphoneFamily {
                        data {
                          id
                          attributes {
                            slug
                            brand
                          }
                        }
                      }
                      combinedPicture {
                        data {
                          id
                          attributes {
                            alternativeText
                            formats
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useLegacyCatalogQuery(baseOptions?: Apollo.QueryHookOptions<LegacyCatalogQuery, LegacyCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacyCatalogQuery, LegacyCatalogQueryVariables>(LegacyCatalogDocument, options);
      }
export function useLegacyCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacyCatalogQuery, LegacyCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacyCatalogQuery, LegacyCatalogQueryVariables>(LegacyCatalogDocument, options);
        }
export type LegacyCatalogQueryHookResult = ReturnType<typeof useLegacyCatalogQuery>;
export type LegacyCatalogLazyQueryHookResult = ReturnType<typeof useLegacyCatalogLazyQuery>;
export type LegacyCatalogQueryResult = Apollo.QueryResult<LegacyCatalogQuery, LegacyCatalogQueryVariables>;